// extracted by mini-css-extract-plugin
export default {"modal":"_-_-record-it-components-src-modal-ModalWithBackdrop-__modal"};